import { createFileRoute } from '@tanstack/react-router';
import { LogsIntegracoesPage } from '@/components/integracoes/logs-page';

export const Route = createFileRoute('/_app/configuracoes/integracoes/logs')({
  component: LogsIntegracoesRota,
});

function LogsIntegracoesRota() {
  return <LogsIntegracoesPage />;
}
